import { useEffect } from 'react';
import { createFileRoute } from '../../utils';

const Home = () => {
  const navigate = Route.useNavigate();

  useEffect(() => {
    navigate({ to: '/app/home' });
  }, []);

  return <div />;
};

export const Route = createFileRoute('/app/')({
  component: Home,
});
